import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { LoginData, LoginResponse } from '../types/Auth';
import { login } from '../api/AuthAPI';
import { getUserMessage, logApiError, parseApiError } from '../api/apiError';

interface LoginFormProps {
    onLoginSuccess: (auth: LoginResponse) => void;
    onSwitchToRegister: () => void;
}

const LoginForm: React.FC<LoginFormProps> = ({ onLoginSuccess }) => {
  const [formData, setFormData] = useState<LoginData>({
    email: '',
    password: '',
  });
  const [error, setError] = useState<string | null>(null);
  const [traceId, setTraceId] = useState<string | null>(null);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    console.log("Form data before submission:", formData);
    e.preventDefault();
    try {
      const response: LoginResponse = await login(formData);
      onLoginSuccess(response);
      setError(null);
    } catch (err) {
        logApiError(err);
        setError(getUserMessage(err));
        setTraceId(parseApiError(err)?.traceId ?? null);
    }
  };

  return (
    <div className="auth-card">
      <h2>Welcome Back</h2>
      <p className="subtitle">Sign in to your account</p>
      <form onSubmit={handleSubmit} className="auth-form">
        <div className="form-group">
          <label htmlFor="email">Email Address</label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Enter your email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <div style={{ position: "relative" }}>
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              name="password"
              placeholder="Enter your password"
              value={formData.password}
              onChange={handleChange}
              required
              style={{ paddingRight: "3.5rem", width: "100%" }}
            />
            <button
              type="button"
              onClick={() => setShowPassword((s) => !s)}
              aria-label={showPassword ? "Hide password" : "Show password"}
              aria-pressed={showPassword}
              style={{
                position: "absolute",
                right: "0.5rem",
                top: "50%",
                transform: "translateY(-50%)",
                background: "transparent",
                border: "none",
                cursor: "pointer",
                fontSize: "0.85rem",
                color: "var(--text-secondary)",
                padding: "0.25rem",
                width: "auto",
              }}
            >
              {showPassword ? "Hide" : "Show"}
            </button>
          </div>
        </div>
        <button type="submit">Sign In</button>
        {error && (
            <p className="error-message">
                {error}
                {traceId && <span className="error-trace">Reference: {traceId}</span>}
            </p>
        )}
      </form>
      <div style={{ marginTop: "0.75rem", textAlign: "center", fontSize: "0.9rem" }}>
          <Link to="/forgot-password">Forgot password?</Link>
      </div>
    </div>
  );
};

export default LoginForm;
